import { IconButton, InputAdornment, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { StyledParams } from 'types/common';
import { InputText } from '../../components/elements/InputText';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import theme from '../../../styles/theme';
import { useInjection } from './hook';
import { ButtonCustom } from '../../components/elements/ButtonCustom';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';

export const SettingPage = () => {
  const { auth } = useAuth();
  const {
    showCurrentPassword,
    setShowCurrentPassword,
    showNewPassword,
    showConfirmNewPassword,
    setShowConfirmNewPassword,
    setShowNewPassword,
    handleSubmit,
    register,
    errors,
    asyncChangePassword,
    isLoading,
    fileInputIconRef,
    handleFileChange,
    fileIcon,
    handleFileClick,
    handleDeleteLogo
  } = useInjection();
  return (
    <WrapperPage>
      <TitlePageStyled>Settings</TitlePageStyled>
      <WrapperForm>
        <TextNormalStyled mb={3.75}>Change Password</TextNormalStyled>
        <Stack gap={1} mb={2}>
          <InputText
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
                  {showCurrentPassword ? (
                    <Visibility sx={{ color: theme.colors.base }} />
                  ) : (
                    <VisibilityOff sx={{ color: theme.colors.base }} />
                  )}
                </IconButton>
              </InputAdornment>
            }
            placeholder={'Current Password'}
            inputError={errors.currentPassword?.message}
            inputProps={{
              ...register('currentPassword'),
              type: showCurrentPassword ? 'text' : 'password'
            }}
          />
        </Stack>
        <Stack gap={1} mb={2}>
          <InputText
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                  {showNewPassword ? (
                    <Visibility sx={{ color: theme.colors.base }} />
                  ) : (
                    <VisibilityOff sx={{ color: theme.colors.base }} />
                  )}
                </IconButton>
              </InputAdornment>
            }
            placeholder={'New Password'}
            inputError={errors.newPassword?.message}
            inputProps={{
              ...register('newPassword'),
              type: showNewPassword ? 'text' : 'password'
            }}
          />
        </Stack>
        <Stack gap={1} mb={2}>
          <InputText
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}>
                  {showConfirmNewPassword ? (
                    <Visibility sx={{ color: theme.colors.base }} />
                  ) : (
                    <VisibilityOff sx={{ color: theme.colors.base }} />
                  )}
                </IconButton>
              </InputAdornment>
            }
            placeholder={'Confirm New Password'}
            inputError={errors.confirmNewPassword?.message}
            inputProps={{
              ...register('confirmNewPassword'),
              type: showConfirmNewPassword ? 'text' : 'password'
            }}
          />
        </Stack>
        <ButtonCustom
          loading={isLoading}
          onClick={handleSubmit(asyncChangePassword)}
          label={'Save'}
        />
        {(auth?.role === Role.SUPER_ADMIN || auth?.role === Role.ADMIN) && (
          <Stack alignItems={'flex-start'} mt={1.5} gap={1}>
            <TextNormalStyled>Logo</TextNormalStyled>
            <Stack gap={0.75} alignItems={'flex-end'}>
              <input
                accept="image/*"
                ref={fileInputIconRef}
                hidden
                onChange={(event) => handleFileChange(event)}
                type="file"
              />
              {fileIcon && (
                <img height={80} style={{ objectFit: 'cover' }} src={fileIcon} alt={'icon'} />
              )}
              {fileIcon ? (
                <IconButton onClick={handleDeleteLogo}>
                  <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />
                </IconButton>
              ) : (
                <IconButton onClick={handleFileClick}>
                  <Stack
                    alignItems={'center'}
                    justifyContent={'center'}
                    bgcolor={'#D9D9D9'}
                    padding={1.8}
                    sx={{ cursor: 'pointer' }}>
                    <img alt={'icon-user'} src={'/icons/icon_logo_upload.svg'} width={53} />
                  </Stack>
                </IconButton>
              )}
            </Stack>
          </Stack>
        )}
      </WrapperForm>
    </WrapperPage>
  );
};
const WrapperPage = styled(Stack)(() => ({
  padding: '40px 30px 0 40px',
  width: '100%',
  height: '100vh'
}));
const WrapperForm = styled(Stack)(() => ({
  padding: '0 30px',
  width: '100%',
  maxWidth: '370px'
}));
const TitlePageStyled = styled(Typography)(({ theme }: StyledParams) => ({
  marginBottom: '30px',
  color: theme.colors.base,
  fontSize: '32px',
  fontWeight: 900,
  fontFamily: `'Avenir',sans-serif`
}));
const TextNormalStyled = styled(Typography)(({ theme }: StyledParams) => ({
  color: theme.colors.base,
  fontSize: '20px',
  fontWeight: 600,
  fontFamily: `'Avenir',sans-serif`
}));
